import React, { useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import Badge from '@mui/material/Badge';
import Box from '@mui/material/Box';
import ExitToApp from '@mui/icons-material/ExitToApp';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HomeIcon from '@mui/icons-material/Home';
import { COMP } from '@lba-dev/package.local-globals/dossier';
import { Call } from '@mui/icons-material';

import logo from '../../public/lesbonsartisansdef.png';
import { assistanceDialog } from '../actions/proposition';

const regex = /^(\/missions(?:\/(ongoing|history|news))?|\/?)$/;
const devisFicheRegex = /^\/devis\/\d+$/;

const useStyles = makeStyles()({
  toolbar: {
    display: 'flex',
    gap: 8,
    padding: '0 4px',
  },
  img: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  btnGroup: {
    display: 'flex',
    gap: 8,
    alignItems: 'center',
  },
  btn: {
    minWidth: 'unset',
    padding: '6px 8px',
  },
});

const LeftButtons = ({ navigate, pageName, user, pagesWithProfile }) => {
  const location = useLocation();
  const { classes } = useStyles();
  const isHome = pageName === '/';
  const pagesWithBackButton = !pagesWithProfile;

  // Header stays mounted across route changes (sibling of <Routes> in
  // Dashboard.js), so this ref tracks in-app navigations rather than the
  // tab's whole browser history (window.history.length also counts pages
  // visited before this app ever loaded).
  const navigationCountRef = useRef(0);
  const prevPageNameRef = useRef(pageName);
  useEffect(() => {
    if (prevPageNameRef.current !== pageName) {
      navigationCountRef.current += 1;
      prevPageNameRef.current = pageName;
    }
  }, [pageName]);

  const handleBackClick = () => {
    const canGoBack = navigationCountRef.current > 0 &&
      !location.state?.isFromExternalLink;
    if (canGoBack) {
      navigate(-1);
      return;
    }
    navigate(devisFicheRegex.test(pageName) ? '/mes-devis' : '/profile');
  };

  return <Box className={classes.btnGroup}>
    {pagesWithBackButton && (
      <IconButton
        onClick={handleBackClick}
        children={<ArrowBackIcon color="primary" />}
      />
    )}
    {!isHome && (
      <IconButton
        onClick={() => navigate('/')}
        children={<HomeIcon color="primary" />}
      />
    )}
    {pagesWithProfile && user && (
      <React.Fragment>
        <Button color="primary"
          className={classes.btn}
          component={Link}
          id="profileButton"
          to={'/profile'}>
          <Badge
            color="secondary"
            badgeContent=" "
            variant="dot"
            invisible={user._dossier === COMP}
          >
            <AccountCircleIcon />
          </Badge>
        </Button>
        <Button color="primary"
          className={classes.btn}
          id='AssistanceButton'
          onClick={() => assistanceDialog()}
        >
          <Call />
        </Button>
      </React.Fragment>
    )}
  </Box>;
};

const Header = ({
  navigate, deconnexion, user, pageName
}) => {
  const { classes } = useStyles()
  const pagesWithProfile = regex.test(pageName);
  return (
    <AppBar
      position="fixed"
      color="default"
      enableColorOnDark
    >
      <Toolbar className={classes.toolbar}>
        <LeftButtons
          pageName={pageName}
          navigate={navigate}
          user={user}
          pagesWithProfile={pagesWithProfile}
        />
        <Box className={classes.img}>
          <img
            src={logo}
            alt="logo"
            onClick={() => navigate('/')}
            width={100}
          />
        </Box>
        <Box className={classes.btnGroup}>
          <Button color="primary"
            className={classes.btn}
            id='faqButton'
            component={Link}
            to={'/faq'}>
            <QuestionMarkIcon />
          </Button>
          <Button color="primary" className={classes.btn}
            onClick={() => deconnexion()}>
            <ExitToApp />
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
